import type { Character } from "@/types/content";

export const characters: Character[] = [
  {
    id: "c1",
    name: "尹瑟琪",
    actor: "李慧彬",
    type: "主角",
    camp: "姜家",
    identity: "姜家女主人 · 姜泰镇的续弦妻子",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elegant%20woman%20in%20her%20early%20thirties%20wearing%20a%20deep%20navy%20silk%20dress%2C%20calm%20yet%20unreadable%20expression%2C%20soft%20moody%20studio%20lighting%2C%20dark%20cool-toned%20background%2C%20subtle%20gold%20highlights%2C%20premium%20Korean%20melodrama%20still%2C%20editorial%20photo%20style&width=600&height=800&seq=char-01&orientation=portrait",
    relations: "丈夫：姜泰镇；继子：姜志勋；对手：白婉婷",
    intro:
      "原名尹秀妍，出身平凡却气质出众。带着不为人知的过往走进姜家，成为会长姜泰镇的续弦妻子。她待人温和、处事滴水不漏，是姜家最令人琢磨不透的存在。",
    keyPlot:
      "从踏入姜家大门的那一刻起，瑟琪便游走于各方势力的试探与算计之间。她一边守护病重的丈夫，一边与逐渐动摇的继子志勋建立信任，也在暗处揭开当年母亲含冤离世的真相。",
    episodeIds: ["e1", "e3", "e5", "e8", "e12", "e16"],
    newsIds: ["n1", "n4"],
  },
  {
    id: "c2",
    name: "姜志勋",
    actor: "金道贤",
    type: "主角",
    camp: "姜家",
    identity: "姜氏集团次子 · 集团继承人",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20composed%20man%20in%20his%20mid%20thirties%20in%20a%20charcoal%20business%20suit%2C%20sharp%20gaze%2C%20restrained%20emotion%2C%20moody%20low-key%20lighting%2C%20dark%20blue%20background%2C%20subtle%20warm%20rim%20light%2C%20premium%20Korean%20melodrama%20still%2C%20editorial%20photo%20style&width=600&height=800&seq=char-02&orientation=portrait",
    relations: "父亲：姜泰镇；继母：尹瑟琪；青梅竹马：徐慧珍",
    intro:
      "姜氏集团最被看好的继承人，冷静、克制、原则分明。母亲早逝的经历让他对父亲再婚极为排斥，也让他在情感上筑起高墙。",
    keyPlot:
      "志勋最初视瑟琪为图谋家产的闯入者，屡次设局试探。然而在集团危机与家族内斗中，他逐渐看到瑟琪的坚韧与真心，两人的关系从对立走向并肩，也走向难以言说的情感漩涡。",
    episodeIds: ["e2", "e4", "e6", "e9", "e13", "e17"],
    newsIds: ["n2", "n5"],
  },
  {
    id: "c3",
    name: "白婉婷",
    actor: "韩珠恩",
    type: "主角",
    camp: "白家",
    identity: "姜氏集团理事 · 会长外甥女",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20ambitious%20woman%20with%20styled%20hair%20and%20a%20dark%20plum%20business%20outfit%2C%20cold%20confident%20smile%2C%20dramatic%20side%20lighting%2C%20deep%20moody%20background%2C%20rich%20shadow%20tones%2C%20premium%20Korean%20melodrama%20still&width=600&height=800&seq=char-03&orientation=portrait",
    relations: "对手：尹瑟琪、姜志勋；倚仗：姜泰镇的血缘",
    intro:
      "姜会长妹妹的女儿，自幼被视为\"半个姜家人\"。她能干、强势、野心勃勃，把集团继承权视为囊中之物，是瑟琪最棘手的对手。",
    keyPlot:
      "婉婷精心布局多年，从财务到舆论步步紧逼。她揭露瑟琪的旧日身份，挑动志勋的疑虑，甚至不惜与外部对手郑泰成联手，只为将姜家收入囊中。",
    episodeIds: ["e3", "e7", "e10", "e14", "e18"],
    newsIds: ["n3", "n6"],
  },
  {
    id: "c4",
    name: "姜泰镇",
    actor: "朴民国",
    type: "配角",
    camp: "姜家",
    identity: "姜氏集团会长 · 瑟琪的丈夫",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20weathered%20dignified%20older%20man%20in%20a%20dark%20wool%20suit%2C%20tired%20but%20authoritative%20expression%2C%20moody%20low-key%20lighting%2C%20dark%20background%20with%20faint%20warm%20tone%2C%20premium%20Korean%20melodrama%20still&width=600&height=800&seq=char-04&orientation=portrait",
    relations: "妻子：尹瑟琪；子女：姜志勋、姜恩星",
    intro:
      "白手起家创立姜氏集团的传奇会长。晚年疾病缠身，却愈发看清身边人的真心与野心，将家族最后的平衡交给瑟琪。",
    keyPlot: "泰镇在病榻上做出关键人事安排，成为全剧转折点。他的选择既是对瑟琪的信任，也彻底点燃了婉婷的危机感。",
    episodeIds: ["e1", "e6", "e11", "e15"],
    newsIds: ["n1"],
  },
  {
    id: "c5",
    name: "徐慧珍",
    actor: "宋智媛",
    type: "配角",
    camp: "中立",
    identity: "调查记者 · 志勋的青梅竹马",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20smart%20young%20female%20journalist%20with%20short%20neat%20hair%20and%20a%20beige%20trench%20coat%2C%20thoughtful%20expression%2C%20soft%20editorial%20lighting%2C%20warm%20neutral%20background%2C%20premium%20Korean%20melodrama%20still&width=600&height=800&seq=char-05&orientation=portrait",
    relations: "青梅竹马：姜志勋；线人关系：尹瑟琪",
    intro:
      "秉持新闻理想的调查记者，与志勋从小一起长大。她理性、独立，是少数能在情感漩涡中保持清醒的角色。",
    keyPlot: "慧珍追查姜家旧案，无意间成为揭开真相的关键。她的报道既伤害了志勋，也让他开始重新审视瑟琪的过去。",
    episodeIds: ["e5", "e9", "e13"],
    newsIds: ["n5"],
  },
  {
    id: "c6",
    name: "姜恩星",
    actor: "柳世拉",
    type: "配角",
    camp: "姜家",
    identity: "姜家小女儿 · 艺术系学生",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20bright%20young%20woman%20in%20her%20early%20twenties%20wearing%20a%20soft%20cream%20knit%20top%2C%20gentle%20hopeful%20expression%2C%20airy%20natural%20lighting%2C%20light%20neutral%20background%2C%20premium%20Korean%20melodrama%20still&width=600&height=800&seq=char-06&orientation=portrait",
    relations: "父亲：姜泰镇；哥哥：姜志勋；亲近：尹瑟琪",
    intro: "姜家最单纯的存在，厌恶家族争斗，把瑟琪当作真正的家人。她的存在让冰冷的姜家保有温度。",
    keyPlot: "恩星意外发现婉婷的秘密账目，成为推动剧情翻转的关键人物，也一度因此身陷危险。",
    episodeIds: ["e2", "e8", "e14"],
    newsIds: ["n7"],
  },
  {
    id: "c7",
    name: "崔承宪",
    actor: "吴成泰",
    type: "配角",
    camp: "姜家",
    identity: "姜家法务顾问 · 崔律师",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20reliable%20middle-aged%20male%20lawyer%20wearing%20round%20glasses%20and%20a%20grey%20suit%2C%20serious%20loyal%20expression%2C%20soft%20office%20lighting%2C%20muted%20neutral%20background%2C%20premium%20Korean%20melodrama%20still&width=600&height=800&seq=char-07&orientation=portrait",
    relations: "效忠：姜泰镇、尹瑟琪",
    intro: "跟随姜会长多年的法务顾问，忠诚而谨慎，掌握着姜家许多不为人知的文件与秘密。",
    keyPlot: "在继承权争夺中，崔律师手中的遗嘱与信托文件成为各方争夺的焦点，他的立场直接影响胜负走向。",
    episodeIds: ["e4", "e11", "e16"],
    newsIds: ["n3"],
  },
  {
    id: "c8",
    name: "郑泰成",
    actor: "白承贤",
    type: "配角",
    camp: "对立",
    identity: "泰成集团会长 · 姜氏宿敌",
    avatar:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20ruthless%20businessman%20in%20a%20black%20turtleneck%20and%20dark%20overcoat%2C%20cunning%20cold%20gaze%2C%20hard%20dramatic%20lighting%2C%20very%20dark%20background%2C%20premium%20Korean%20melodrama%20still&width=600&height=800&seq=char-08&orientation=portrait",
    relations: "合作：白婉婷；宿敌：姜氏集团",
    intro: "与姜会长斗了半辈子的商界枭雄，行事狠辣、城府极深，惯于借刀杀人。",
    keyPlot: "郑泰成表面与婉婷结盟，实则伺机吞并姜氏。他在终局的反水，让所有算计瞬间反转。",
    episodeIds: ["e10", "e15", "e18"],
    newsIds: ["n6"],
  },
];